// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import {
	createGAEvent,
	GaGeneralEvent,
	GaGeneralPageName,
} from '@/assets/ts/customEvent'
import { setCurrentGaPageName, getCurrentGaPageName } from '@/lib/utils'
import OnboardingPage from '@/pages/onboarding/components/_OnboardingPage.vue'

hybridPage()

createApp({
	name: 'Onboarding',
	components: {
		OnboardingPage,
	},
	setup() {
		setCurrentGaPageName(GaGeneralPageName.UserPreferencePage)
		createGAEvent(GaGeneralEvent.PageLoad, {
			page_name: getCurrentGaPageName(),
		})

		const { onboardingPageContent } = window.pageContent

		return {
			onboardingPageContent,
		}
	},
}).mount('#bsMain')
